// Countertops/Cabinets manual estimate — persistence action types.
// Follows the existing *_REQUEST / *_SUCCESS / *_FAILED feature-triad convention.

export const CC_ESTIMATE_SAVE_REQUEST = "@CC_ESTIMATE_SAVE_REQUEST";
export const CC_ESTIMATE_SAVE_SUCCESS = "@CC_ESTIMATE_SAVE_SUCCESS";
export const CC_ESTIMATE_SAVE_FAILED = "@CC_ESTIMATE_SAVE_FAILED";

export const CC_ESTIMATE_LOAD_REQUEST = "@CC_ESTIMATE_LOAD_REQUEST";
export const CC_ESTIMATE_LOAD_SUCCESS = "@CC_ESTIMATE_LOAD_SUCCESS";
export const CC_ESTIMATE_LOAD_FAILED = "@CC_ESTIMATE_LOAD_FAILED";

export const CC_ESTIMATE_STATE_CHANGE = "@CC_ESTIMATE_STATE_CHANGE";

export const CC_SCOPE_PHOTO_UPLOAD_REQUEST = "@CC_SCOPE_PHOTO_UPLOAD_REQUEST";
export const CC_SCOPE_PHOTO_UPLOAD_SUCCESS = "@CC_SCOPE_PHOTO_UPLOAD_SUCCESS";
export const CC_SCOPE_PHOTO_UPLOAD_FAILED  = "@CC_SCOPE_PHOTO_UPLOAD_FAILED";

export const CC_SCOPES_REQUEST = "@CC_SCOPES_REQUEST";
export const CC_SCOPES_SUCCESS = "@CC_SCOPES_SUCCESS";
export const CC_SCOPES_FAILED  = "@CC_SCOPES_FAILED";
